/** Inline SVG icons for the drawing toolbar — no icon-font dependency. */
export function ToolIcon({ name, size = 18 }: { name: string; size?: number }) {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
  };
  switch (name) {
    case "cursor":
      return <svg {...common}><path d="M4 3l7 17 2.5-7L21 10.5 4 3z" /></svg>;
    case "trend":
      return <svg {...common}><path d="M4 19L20 5" /><circle cx="4" cy="19" r="2" /><circle cx="20" cy="5" r="2" /></svg>;
    case "ray":
      return <svg {...common}><path d="M4 19L20 5" /><circle cx="4" cy="19" r="2" /><path d="M17 5h4v4" /></svg>;
    case "hline":
      return <svg {...common}><path d="M3 12h18" /><circle cx="12" cy="12" r="2" /></svg>;
    case "vline":
      return <svg {...common}><path d="M12 3v18" /><circle cx="12" cy="12" r="2" /></svg>;
    case "rect":
      return <svg {...common}><rect x="4" y="6" width="16" height="12" rx="1" /></svg>;
    case "fib":
      return <svg {...common}><path d="M3 5h18M3 10h18M3 14h18M3 19h18" /></svg>;
    case "ruler":
      return <svg {...common}><path d="M5 12h14M5 9v6M19 9v6" /><path d="M9 10v4M14 10v4" /></svg>;
    case "text":
      return <svg {...common}><path d="M5 6h14M12 6v12M9 18h6" /></svg>;
    case "pattern":
      // Legs of a zig-zag: the shape every harmonic and wave tool is.
      return <svg {...common}><path d="M3 17l4-7 4 4 3-8 4 11" /></svg>;
    case "pencil":
      return <svg {...common}><path d="M4 20l1.5-4.5L16 5l3 3L8.5 18.5 4 20z" /></svg>;
    case "magnet":
      return <svg {...common}><path d="M6 4v7a6 6 0 0012 0V4" /><path d="M6 4h4M14 4h4M6 9h4M14 9h4" /></svg>;
    case "eye":
      return <svg {...common}><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7z" /><circle cx="12" cy="12" r="3" /></svg>;
    case "eye-off":
      return <svg {...common}><path d="M4 4l16 16" /><path d="M9.9 5.2A10 10 0 0112 5c6.4 0 10 7 10 7a18 18 0 01-3.1 3.9M6.3 7.3A18 18 0 002 12s3.6 7 10 7a10 10 0 004.2-.9" /><path d="M9.9 9.9a3 3 0 004.2 4.2" /></svg>;
    case "gear":
      return <svg {...common}><circle cx="12" cy="12" r="3" /><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M19.1 4.9L17 7M7 17l-2.1 2.1" /></svg>;
    case "more":
      return <svg {...common}><circle cx="5" cy="12" r="1.3" fill="currentColor" /><circle cx="12" cy="12" r="1.3" fill="currentColor" /><circle cx="19" cy="12" r="1.3" fill="currentColor" /></svg>;
    case "close":
      return <svg {...common}><path d="M6 6l12 12M18 6L6 18" /></svg>;
    case "trash":
      return <svg {...common}><path d="M4 7h16M9 7V5h6v2M7 7l1 13h8l1-13" /></svg>;
    default:
      return <svg {...common}><circle cx="12" cy="12" r="8" /></svg>;
  }
}
